export const AVAILABILITY_REPORT_XLSX_CONTENT_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const AVAILABILITY_REPORT_DEFAULT_FILE_NAME = 'availability-report.xlsx';

export const AVAILABILITY_REPORT_ENDPOINT_PATH = '/site-availability-report';

export const DAY_START = '00:00';

export const AVAILABILITY_REPORT_MODAL_TITLE = 'Download availability';
export const AVAILABILITY_REPORT_MODAL_DESCRIPTION =
  'Please choose the date range for your availability report (.xlsx file).';

export const DATE_RANGE_END_OFFSET_DAYS = 1;

export enum TimePeriodType {
  Custom = 'Custom',
  Yesterday = 'Yesterday',
  LastWeek = 'Last week',
  LastMonth = 'Last month',
}
